import {
    useNavigate,
} from 'react-router-dom'
import SkyBaseCreateButton
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components/SkyBaseDataGridToolbar/SkyBaseCreateButton'

type Props = {
    isMenuItem?: boolean
}
const CreateButton = ({
    isMenuItem = false,
}: Readonly<Props>) => {
    const navigate = useNavigate()

    const handleCreate = () => {
        navigate('./create')
    }

    return (
        <SkyBaseCreateButton
            onClick={handleCreate}
            isMenuItem={isMenuItem}
        />
    )
}

export default CreateButton
